import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    covidSearchMixin
} from './vue/mixins/covid';
import lazyload from './features/lazy-load';

lazyload();

initMain([covidSearchMixin], {
    CovidTop: () => import('./vue/components/covid-top/CovidTop.vue'),
    CovidGraph: () => import('./vue/components/covid-graph/CovidGraph.vue')
}, []);
header();